export default __webpack_public_path__ + "static/media/=AFISHA FR.tif copy.e67a2a35.jpg";